export const AI_TUTOR_ASIDE_WIDTH_KEY = "ai-tutor-aside-width";

/** Верхняя граница fixed-панели AI Tutor на десктопе — под глобальным хедером (z-index панели выше хедера). */
export const AI_TUTOR_DESKTOP_TOP = "var(--header-height, 4.5rem)";

export const AI_TUTOR_MIN_WIDTH = 280;
export const AI_TUTOR_MAX_WIDTH = 600;
export const AI_TUTOR_DEFAULT_WIDTH = 450;

